'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.COMMANDS = exports.CHECKLIST_BLOCK_TYPE = undefined;

var _richTextConstants = require('../../richText/richTextConstants');

var CHECKLIST_BLOCK_TYPE = exports.CHECKLIST_BLOCK_TYPE = _richTextConstants.STYLE_COMMANDS.CHECKLIST; // TODO Rethink how this is structured
var COMMANDS = exports.COMMANDS = {
    MOVE_SELECTION_TO_END_OF_PREVIOUS_BLOCK: 'move-selection-to-end-of-prev-block'
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/checklist/checklistConstants.js
// module id = 196
// module chunks = 0